// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Modal from '@localytics/loc-components/lib/Modal';
import Button from '@localytics/loc-components/lib/Button';
import withLeaveDialog from './withLeaveDialog';
import { updateOrchestrationLimit } from '../actions/api';
import { getQueryParams } from '../util/RouterUtils';
import './stylesheets/ReEntryModal.scss';

type ReEntryModalProps = {
  orgId: number,
  updateOrchestrationLimit: Function,
  orchestrationId: number,
  showModal: boolean,
  onCloseCallback: Function,
  currentValue: number | ''
};

type State = {
  selectedValue: number | '',
  hasValidReEntry: boolean
};

export class ReEntryModal extends Component<ReEntryModalProps, State> {
  state = {
    selectedValue: this.props.currentValue,
    hasValidReEntry: false
  };

  // use getDerivedStateFromProps if we upgrade to react 16.3+
  componentWillReceiveProps(nextProps: ReEntryModalProps) {
    if (this.props.currentValue !== nextProps.currentValue) {
      this.setState({ selectedValue: nextProps.currentValue });
    }
  }

  setValue: Function = event => {
    const isValid = event.target.checkValidity();
    this.setState({
      selectedValue: isValid ? event.target.value : this.props.currentValue,
      hasValidReEntry: isValid
    });
  };

  submitValue: Function = () => {
    const { selectedValue, hasValidReEntry } = this.state;
    if (hasValidReEntry) {
      this.props.updateOrchestrationLimit(
        this.props.orgId,
        this.props.orchestrationId,
        selectedValue
      );
      this.props.onCloseCallback();
    }
  };

  removeLimit: Function = () => {
    this.props.updateOrchestrationLimit(
      this.props.orgId,
      this.props.orchestrationId,
      null
    );
    this.setState({ selectedValue: '' });
    this.props.onCloseCallback();
  };

  focusReentryInput: Function = input => {
    if (input) {
      input.focus();
    }
  };

  // TODO: add warning that this affects every orchestration version? (whereas event group does not)
  render() {
    const ModalWithLeaveDialog = withLeaveDialog(Modal);
    return (
      <ModalWithLeaveDialog
        className="ReEntryModal"
        show={this.props.showModal}
        onHide={this.props.onCloseCallback}
      >
        <div className="ReEntryModal__Content">
          Users can re-enter up to
          <div className="ReEntryModal__Content__Input">
            <input
              className="ReEntryModal__Input"
              type="number"
              value={this.state.selectedValue}
              step={1}
              min={0}
              onChange={this.setValue}
              onInvalid={e => e.preventDefault()}
              ref={this.focusReentryInput}
            />
          </div>
          times
          <div className="ReEntryModal__Content__Buttons">
            <div className="ReEntryModal__Content__Buttons__Left">
              <Button
                size="large"
                label="Remove Limit"
                tabIndex={-1}
                onClick={this.removeLimit}
              />
            </div>
            <Button
              size="large"
              label="Cancel"
              tabIndex={-1}
              onClick={this.props.onCloseCallback}
            />
            <Button
              type="primary"
              size="large"
              label="Save Changes"
              tabIndex={-1}
              onClick={this.submitValue}
              disabled={
                !this.state.hasValidReEntry || this.state.selectedValue === ''
              }
            />
          </div>
        </div>
      </ModalWithLeaveDialog>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { orgId, orchestrationId } = getQueryParams(ownProps.location);
  return {
    orgId,
    orchestrationId
  };
};

const mapDispatchToProps = {
  updateOrchestrationLimit
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReEntryModal)
);



// WEBPACK FOOTER //
// ./src/components/ReEntryModal.jsx